import React from 'react'
import { cn } from 'cn'
import FieldDescription from 'components/ui/FieldDescription'
import FieldError from 'components/ui/FieldError'

export type Props = {
  label?: React.ReactElement | string
  description?: React.ReactElement | string
  value: boolean
  onChange: (value: boolean) => void
  error?: string | null
  size?: 'base' | 'large'
  disabled?: boolean
  newDesign?: boolean
}

export default function CheckBox({
  label,
  description,
  error,
  value,
  onChange,
  disabled = false,
  size = 'base',
  newDesign
}: Props) {
  return (
    <div className="w-full">
      <label className="inline-flex items-start">
        <input
          checked={value}
          className={cn(
            'mt-1 rounded-sm border-gray-300 shadow-xs focus:ring-3 scroll-offset text-orange-500 focus:border-orange-500 focus:ring-orange-500/50',
            {
              'border-red-500 ring-3 ring-red-500/50': error,
              'w-5 h-5': size === 'large',
              'opacity-40': disabled
            }
          )}
          disabled={disabled}
          onChange={() => onChange(!value)}
          type="checkbox"
        />
        <span
          className={cn('ml-2', {
            'font-theme-heading font-bold text-gray-900': newDesign
          })}
        >
          {label}
        </span>
      </label>
      <FieldError>{error}</FieldError>
      <FieldDescription>{description}</FieldDescription>
    </div>
  )
}
